import { render, staticRenderFns } from "./listacatalogomobile.vue?vue&type=template&id=1a23ee00&scoped=true&"
import script from "./listacatalogomobile.vue?vue&type=script&lang=js&"
export * from "./listacatalogomobile.vue?vue&type=script&lang=js&"
import style0 from "./listacatalogomobile.vue?vue&type=style&index=0&id=1a23ee00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a23ee00",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/ALIO/APP/APPVentas/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDataIterator } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VProgressLinear } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VAlert,VCard,VCardText,VCardTitle,VContainer,VDataIterator,VFlex,VImg,VLayout,VList,VProgressLinear,VSelect,VTextField})
